<template>
  <div>
    <breadcrumbs class="mb-32" />
    <transition name="fade" mode="out-in">
      <keep-alive>
        <router-view :key="$route.fullPath" />
      </keep-alive>
    </transition>
  </div>
</template>

<script>
  import breadcrumbs from '@/components/Breadcrumbs.vue'
  export default {
    components: {
      breadcrumbs
    }
  }
</script>
